import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type Store from '@ember-data/store'
import type SubscriptionTypeRoute from 'teacher-ui-client/subscription-type/route'
import type AssignmentsRoute from 'teacher-ui-client/assignments/route'
import type AssignmentsProductRoute from 'teacher-ui-client/assignments/product/route'
import type Teacher from 'teacher-ui-client/models/teacher'

export default class AssignmentsProductCreateRoute extends Route {
  @service store!: Store

  queryParams = {
    activityType: {
      replace: true,
    },
    bookCode: {},
    writingCode: {},
    ewiCode: {},
  }

  model() {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelFor<SubscriptionTypeRoute>
    const { schoolClasses, students } = this.modelFor('assignments') as ModelFor<AssignmentsRoute>
    const { assignmentProduct } = this.modelFor('assignments.product') as ModelFor<AssignmentsProductRoute>

    const teachers = this.store.peekAll<Teacher>('teacher')
    return {
      subscriptionType,
      assignmentProduct,
      teachers,
      schoolClasses,
      students,
    }
  }
}
